import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { useTranslation } from '@common/hooks/useTranslation';
import { WorkExperience as WorkExperienceEnum } from '@seek/je-shared-data/lib/types/jobs';
import { workExperienceRules } from '../../rules';
import { WorkExperienceField } from './WorkExperienceField';

type WorkExperienceProps<T extends FieldValues> = UseControllerProps<T> & {
  overrides?: {
    label?: string;
    options?: { key: WorkExperienceEnum; label: string }[];
  };
};

export function WorkExperience<T extends FieldValues>({
  name,
  control,
  overrides
}: WorkExperienceProps<T>) {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={workExperienceRules(t)}
      render={({ field: { onChange, value }, formState }) => (
        <WorkExperienceField
          onChange={onChange}
          label={overrides?.label}
          options={overrides?.options}
          value={value}
          error={formState?.errors[name]?.message as string}
        />
      )}
    />
  );
}
